import axios from 'axios';
import { baseURL } from '../Constants';
import { PlayerStats } from '../models/PlayerStats';

const url = `${baseURL}/PlayerStat`;
const fantasyUrl = `${baseURL}/Fantasy`;

export const getPlayersByTeamId = async (teamId: string, season: number): Promise<PlayerStats[]> => {
    try {
        const response = await axios.get(`${url}/getPlayersByTeamId`, { params: { teamid: teamId, season } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * A team's players with stats from one division only (exact matches.division, e.g. "1div", so no
 * kval maps), plus this season's roster players with no maps anywhere yet, so new signings still show.
 */
export const getPlayersByTeamIdInDivision = async (teamId: string, season: number, division: string): Promise<PlayerStats[]> => {
    const [inDivision, wholeSeason] = await Promise.all([
        axios.get<PlayerStats[]>(`${url}/getPlayersByTeamId`, { params: { teamid: teamId, season, division } }).then((r) => r.data ?? []),
        // 404s when the team has nobody at all, which only means there is no one to add.
        getPlayersByTeamId(teamId, season).catch((): PlayerStats[] => []),
    ]);
    const shown = new Set(inDivision.map((p) => p.steamID));
    return [...inDivision, ...wholeSeason.filter((p) => p.gamesPlayed === 0 && !shown.has(p.steamID))];
};

export const getFantasyPlayersByTeamId =async (teamId: string, season: number): Promise<PlayerStats[]> => {
    try {
        const response = await axios.get(`${fantasyUrl}/getPlayersByTeamId`, { params: { teamid: teamId, season } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getPlayersByTeamIdLatestFirst = async (teamId: string, season: number, latestFirst: boolean): Promise<PlayerStats[]> => {
    try {
        const response = await axios.get(`${url}/getPlayersByTeamId`, { params: { teamid: teamId, season, latestFirst} });
        return response.data;
    } catch (error) {
        throw error;
    }
};
